import * as yup from "yup";

const createRoentgenReportSchema = yup.object({
  clinic: yup.string().required(),
  date: yup.date().required(),
});

export type RoentgenReportBase = yup.InferType<typeof createRoentgenReportSchema>;

export default createRoentgenReportSchema;
